var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-items"},_vm._l((_vm.notifications),function(item,index){return _c('NotificationItem',{key:index,attrs:{"id":item._id,"title":item.title,"description":item.description,"link":`/account/notification/${item._id}`,"isCompleted":item.isCompleted,"createdAt":item.createdAt}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }